import React, { useEffect, useState } from 'react';
import Modal from './Modal';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleXmark } from '@fortawesome/free-regular-svg-icons';
import PrimaryButton from "../components/PrimaryButton";
import SecondaryButton from "../components/SecondaryButton";
import Input from "../components/Input.js";
import { formatValue } from '../utils/formatValue.js';
import axiosInstance from '../axiosConfig.js';
import { handleError } from '../services/handleError.js';

function ListaProdutos({ produtos, onAddProduct }) {
    const [isModalAddProduct, setIsModalAddProduct] = useState(false);
    const [selectedItem, setSelectedItem] = useState(null);
    const [quantidade, setQuantidade] = useState(1);
    const [observacao, setObservacao] = useState("");
    const [errorMessage, setErrorMessage] = useState("");
    const [adicionaisProduto, setAdicionaisProduto] = useState([]);
    const [perguntasProduto, setPerguntasProduto] = useState([]);
    const [dividirAoMeio, setDividirAoMeio] = useState(false);
    const [produtosMeioaMeio, setProdutosMeioaMeio] = useState([]);
    const [outraMetade, setOutraMetade] = useState();
    const [dropdownAberto, setDropdownAberto] = useState(false);
    const metadeSelecionada = produtosMeioaMeio.find(p => p.id === outraMetade);

    const openModal = (item) => {
        setAdicionaisProduto([]);
        setPerguntasProduto([]);
        if (item) {
            buscarAdicionaisProduto(item.id);
            buscarPerguntasProduto(item.id);
            setSelectedItem(item);
            setIsModalAddProduct(true);
        }
    };

    useEffect(() => {
        buscarMeioaMeio();
    }, []);

    const closeModal = () => {
        setIsModalAddProduct(false);
        setSelectedItem(null);
        setQuantidade(1);
        setObservacao("");
        setErrorMessage(""); // Limpa mensagem de erro
    };

    const handleAddProduct = () => {
        if (quantidade < 1) {
            setErrorMessage("A quantidade deve ser maior que zero.");
            return;
        }

        if (dividirAoMeio) {
            selectedItem.metade = outraMetade;
            let metade = produtosMeioaMeio.find(p => p.id === outraMetade);
            if (metade.valor > selectedItem.valor) {
                selectedItem.valor = metade.valor;
            }
            selectedItem.titulo = "1/2 " + selectedItem.titulo + " + 1/2 " + metade.titulo;
        }

        selectedItem.adicionais = adicionaisProduto.filter(adicional => adicional.adicionado);

        selectedItem.perguntas = perguntasProduto
            .filter(p => p.selecionada != null)
            .map(p => ({
                PerguntaId: p.id,
                OpcaoId: p.selecionada,
                ValorExtra: p.opcoes.find(o => o.id === p.selecionada)?.valorExtra || 0,
                TextoPergunta: p.texto,
                TextoResposta: p.opcoes.find(o => o.id === p.selecionada)?.texto || "",
            }));

        onAddProduct(selectedItem, quantidade, observacao);
        setAdicionaisProduto([])
        setPerguntasProduto([])
        closeModal();
    };

    const selecionarOpcao = (perguntaId, opcaoId) => {
        setPerguntasProduto(prevPerguntas =>
            prevPerguntas.map(p =>
                p.id === perguntaId ? { ...p, selecionada: opcaoId } : p
            )
        );
    };

    const handleQuantityChange = (value) => {
        if (isNaN(value) || value < 0.001) {
            setErrorMessage("A quantidade deve ser maior que zero.");
            setQuantidade(1);
        } else {
            setErrorMessage("");
            setQuantidade(value);
        }
    };

    const incrementQuantity = () => {
        const incremento = selectedItem?.porKg ? 0.1 : 1;
        setQuantidade((prev) => parseFloat((prev + incremento).toFixed(3)));
    };

    const decrementQuantity = () => {
        const incremento = selectedItem?.porKg ? 0.1 : 1;
        setQuantidade((prev) => {
            const novaQtd = prev - incremento;
            return novaQtd < 0.001 ? 0.001 : parseFloat(novaQtd.toFixed(3));
        });
    };

    async function buscarAdicionaisProduto(produtoId) {
        try {
            var rota = produtoId === undefined ? "Adicionais" : `Adicionais/produto/${produtoId}/disponiveis`
            const response = await axiosInstance.get(rota);

            setAdicionaisProduto(response.data)
        } catch (error) {
            handleError(error, "Falha ao carregar os dados.");
        }
    };

    async function buscarPerguntasProduto(produtoId) {
        try {
            const response = await axiosInstance.get(`Produto/${produtoId}/perguntas`);
            setPerguntasProduto(response.data);
        } catch (error) {
            handleError(error, "Falha ao carregar as perguntas do produto.");
        }
    }

    async function buscarMeioaMeio() {
        try {
            const response = await axiosInstance.get("Produto/MeioMeio");

            setProdutosMeioaMeio(response.data)
        } catch (error) {
            handleError(error, "Erro ao buscar adicionais.");
        }
    };

    const toggleSelecionado = (id) => {
        setAdicionaisProduto(prevState => {
            return prevState.map(adicional => {
                if (adicional.id === id) {
                    const totalAdicionados = prevState.filter(ap => ap.adicionado).length;
                    const estaSelecionado = adicional.adicionado;

                    if (selectedItem.max_Adicionais > 0) {
                        if (!estaSelecionado && totalAdicionados >= selectedItem.max_Adicionais) {
                            handleError(`Você pode selecionar apenas ${selectedItem.max_Adicionais} acompanhamentos nesse produto`);
                            return adicional;
                        }
                    }

                    return { ...adicional, adicionado: !adicional.adicionado };
                }
                return adicional;
            });
        });
    };

    return (
        <>
            {Object.keys(produtos).map(categoria => (
                <div key={categoria} className='mt-4'>
                    <span className='text-lg font-bold'>{categoria}:</span>
                    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
                        {produtos[categoria].map((item) => (
                            <div
                                key={item.id}
                                onClick={() => openModal(item)}
                                className="bg-gray-200 rounded-[10px] text-lg text-center h-32 space-x-2 sm:space-x-1 flex cursor-pointer hover:shadow-md hover:bg-gray-300 transition-all duration-200 ease-in-out transform"
                            >
                                <div className="w-1/2">
                                    <img
                                        src={item.url_Imagem}
                                        alt={item.titulo}
                                        className="w-full h-full object-cover rounded-[10px] transition-opacity duration-300"
                                    />
                                </div>

                                <div className="h-full w-full flex items-center justify-center">
                                    <div>
                                        <span className='block font-semibold sm:font-bold sm:text-xl'>{item.titulo}</span>

                                        {item.emPromocao ? (
                                            <div className="flex flex-col items-center">
                                                <span className="text-red-500 font-bold">
                                                    {formatValue(item.valorPromocional)}{item.porKg ? "/Kg" : ""}
                                                </span>
                                                <span className="line-through text-gray-500 text-sm">
                                                    {formatValue(item.valor)}{item.porKg ? "/Kg" : ""}
                                                </span>
                                            </div>
                                        ) : (
                                            <span className='block'>
                                                {formatValue(item.valor)}{item.porKg ? "/Kg" : ""}
                                            </span>
                                        )}
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            ))}

            {isModalAddProduct && (
                <Modal isOpen={isModalAddProduct} onClose={closeModal}>
                    <div className="text-black mb-2 flex justify-between items-center">
                        <span className="text-xl font-semibold">Adicionar Produto</span>
                        <button onClick={closeModal}>
                            <FontAwesomeIcon icon={faCircleXmark} className="text-3xl" />
                        </button>
                    </div>
                    <div className="rounded-full bg-gray-300 my-2" style={{ height: '2.5px' }} />

                    <div className="space-y-4">
                        <div className="rounded-[10px] text-lg text-center h-32 flex">
                            <div className="w-1/2">
                                <img
                                    src={selectedItem?.url_Imagem}
                                    alt={selectedItem?.titulo}
                                    className="w-full h-full object-contain rounded-[10px]"
                                />
                            </div>

                            <div className="h-full w-full flex justify-center items-center">
                                <div className='w-full'>
                                    <span className='block font-bold text-xl'>{selectedItem?.titulo}</span>
                                    {selectedItem.emPromocao ? (
                                        <div className="flex flex-col items-center">
                                            <span className="text-red-500 font-bold">
                                                <span>{formatValue(selectedItem?.valorPromocional) + (selectedItem.porKg ? "/Kg" : "")}</span>
                                            </span>
                                            <span className="line-through text-gray-500 text-sm">
                                                {formatValue(selectedItem.valor)}{selectedItem.porKg ? "/Kg" : ""}
                                            </span>
                                        </div>
                                    ) : (
                                        <span className='block'>{formatValue(selectedItem?.valor) + (selectedItem.porKg ? "/Kg" : "")}</span>
                                    )}

                                    <div className="flex items-center space-x-2 mt-3">
                                        <button onClick={decrementQuantity} className="p-2 bg-gray-300 rounded-lg">-</button>
                                        <Input
                                            type="number"
                                            step="0.001"
                                            placeholder="Quantidade"
                                            value={quantidade}
                                            onChange={(e) => handleQuantityChange(parseFloat(e))}
                                            min={0.001}
                                            className="w-20 text-center"
                                        />
                                        <button onClick={incrementQuantity} className="p-2 bg-gray-300 rounded-lg">+</button>
                                    </div>
                                    {errorMessage && (
                                        <div className="text-red-500 text-sm">{errorMessage}</div>
                                    )}
                                </div>
                            </div>
                        </div>

                        {selectedItem.permiteDivisao &&
                            <>
                                <div className={`flex items-center justify-between`}>
                                    <span className="text-lg">Deseja combinar outro sabor?</span>
                                    <button
                                        type="button"
                                        onClick={() => setDividirAoMeio(!dividirAoMeio)}
                                        className={`relative inline-flex h-6 w-12 items-center rounded-full transition-colors focus:outline-none focus:ring-2 focus:ring-offset-2 ${dividirAoMeio ? 'bg-blue-500' : 'bg-gray-300'}`}
                                    >
                                        <span
                                            className={`inline-block h-4 w-4 transform rounded-full bg-white transition-transform ${dividirAoMeio ? 'translate-x-7' : 'translate-x-1'}`}
                                        />
                                    </button>
                                </div>
                            </>
                        }
                        {dividirAoMeio && (
                            <div className="relative mt-2">
                                <button
                                    onClick={() => setDropdownAberto(!dropdownAberto)}
                                    className="w-full p-3 rounded-[10px] text-left border-2"
                                >
                                    {metadeSelecionada ? (
                                        <>
                                            <div className="text-gray-800 font-medium">{metadeSelecionada.titulo}</div>
                                            <div className="text-sm text-gray-400">{metadeSelecionada.descricao}</div>
                                        </>
                                    ) : (
                                        <span className="text-gray-400">Selecione a outra metade</span>
                                    )}
                                </button>

                                {dropdownAberto && (
                                    <div className="absolute w-full max-h-60 overflow-auto bg-white border-2 rounded-[10px] shadow-lg">
                                        {produtosMeioaMeio
                                            .filter(p => p.id !== selectedItem.id)
                                            .map(prod => (
                                                <div
                                                    key={prod.id}
                                                    onClick={() => {
                                                        setOutraMetade(prod.id);
                                                        setDropdownAberto(false);
                                                    }}
                                                    className="p-3 hover:bg-gray-200 cursor-pointer"
                                                >
                                                    <div className="text-gray-600 font-medium">{prod.titulo}</div>
                                                    <div className="text-sm text-gray-400">{prod.descricao}</div>
                                                </div>
                                            ))}
                                    </div>
                                )}
                            </div>
                        )}

                        {adicionaisProduto.length > 0 &&
                            <>
                                <div className="mt-4">
                                    <span className="text-xl font-semibold">Acompanhamentos:</span>
                                    <table className="w-full">
                                        <thead>
                                            <tr>
                                                <th className="p-2">Nome</th>
                                                <th className="p-2">Valor Extra</th>
                                                <th className="p-2">Adicionar</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {adicionaisProduto.map(adicional => (
                                                <tr key={adicional.id} className="text-center">
                                                    <td className="p-2">{adicional.nome}</td>
                                                    <td className="p-2">{adicional.valorExtra === 0.00 ? "Gratuito" : formatValue(adicional.valorExtra)}</td>
                                                    <td className="p-2">
                                                        <input
                                                            type="checkbox"
                                                            checked={adicional.adicionado}
                                                            onChange={() => toggleSelecionado(adicional.id)}
                                                            className="form-checkbox text-blue-600 w-5 h-5 border-2 border-gray-300 focus:ring-1 focus:ring-blue-500"
                                                        />
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </>
                        }

                        {perguntasProduto?.length > 0 && (
                            <div className="mt-4">
                                <span className="text-xl font-semibold">Opções:</span>
                                {perguntasProduto.map((pergunta) => (
                                    <div key={pergunta.id} className="border-b pb-2">
                                        <span className="font-medium">{pergunta.texto}</span>
                                        <div className="mt-1 space-y-1">
                                            {pergunta.opcoes.map((opcao) => (
                                                <label key={opcao.id} className="flex items-center space-x-2">
                                                    <input
                                                        type="radio"
                                                        name={`pergunta-${pergunta.id}`}
                                                        value={opcao.id}
                                                        checked={pergunta.selecionada === opcao.id}
                                                        onChange={() => selecionarOpcao(pergunta.id, opcao.id)}
                                                        className="form-radio text-blue-600 w-5 h-5 border-gray-300"
                                                    />
                                                    <span>{opcao.texto} {opcao.valorExtra > 0 && `(+ ${formatValue(opcao.valorExtra)})`}</span>
                                                </label>
                                            ))}
                                        </div>
                                    </div>
                                ))}
                            </div>
                        )}

                        <textarea
                            placeholder="Adicione uma observação"
                            value={observacao}
                            onChange={(e) => setObservacao(e.target.value)}
                            className="w-full p-2 border border-gray-300 rounded-lg"
                        />
                    </div>

                    <div className="flex items-center justify-between space-x-2 mt-3">
                        <SecondaryButton onClick={closeModal}>Cancelar</SecondaryButton>
                        <PrimaryButton onClick={handleAddProduct}>Adicionar</PrimaryButton>
                    </div>
                </Modal>
            )}
        </>
    );
}

export default ListaProdutos;
